module.exports = __webpack_public_path__ + "static/media/4-1.3831fcdd.jpg";